<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>{{ title }}</span>
    </div>
    <slot name="body"></slot>
    <el-row>
      <el-col class="card-footer">
        <hr />
       <slot name="footer"></slot>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style scoped>
.card-footer {
  text-align: right;
}
</style>
